import * as Scrivito from "scrivito";

Scrivito.provideComponent("SectionContentWidget", ({ widget }) => {
  const sectionClassNames = [];

  sectionClassNames.push(`bg-${widget.get("backgroundColor")}`);
  sectionClassNames.push(
    `s-${widget.get("padding")} ${
      widget.get("largeTopPadding") ? "--large" : "--default"
    }`
  );

  const background = widget.get("background");
  const isImage = background
    ?.get("blob")
    .raw()
    .metadata()
    .contentType()
    .startsWith("image");

  const isVideo = background
    ?.get("blob")
    .raw()
    .metadata()
    .contentType()
    .startsWith("video");

  (isImage || isVideo) &&
    sectionClassNames.push(`bg-${widget.get("backgroundColor")}-blur`);
  const style =
    (isImage && {
      "--blur-strength": "7px",
      "--opacity": "0.7",
      backgroundImage: `url(${Scrivito.urlFor(background)})`,
    }) ||
    null;

  let contentClassName = "container";
  if (widget.get("useFullWidth") === "yes") {
    contentClassName = "container-fluid mx-0 px-0";
  }

  return (
    <section className={sectionClassNames.join(" ")} style={style}>
      {isVideo && (
        <div className="background-video-wrapper">
          <video
            src={Scrivito.urlFor(background)}
            controls={false}
            autoPlay={true}
            muted={true}
            loop={true}
            playsInline
            preload="auto"
          />
        </div>
      )}
      <Scrivito.ContentTag
        className={contentClassName}
        content={widget}
        attribute="content"
      />
    </section>
  );
});
